/**
 * THE REVISIONS OF THE HELP WORDING A PERSON AGREES TO — plan-019 INT (wave-2 close; design §31.8.4, §31.3.2; OD-7,
 * OD-8; SEC-HA-11, SEC-HA-13). Moved here from the help host, the widget and the api so that every reader holds ONE
 * constant: the widget shows the wording, the help host records `help_conversation.notice_revision`, and the api
 * compares a visitor's `consent_revision` with the current one.
 *
 * A change of wording is a NEW revision here, in the same commit as the new words in the widget's catalogs — never an
 * edit of the words under an old revision.
 *
 * Imports nothing: the widget's panel chunk reads it through the lean subpath `@wetalk/domain/help/revision`.
 */
/**
 * The privacy notice shown before a help conversation's first message (design §31.8.4, worded after OD-8: the records
 * are kept, deletion on request). Recorded on every help conversation and sent with every help request.
 */
export const HELP_NOTICE_REVISION = "help-notice-2026-10-15";
/**
 * The consent an anonymous visitor gives before a help request keeps their email address (OD-7; the waitlist rule:
 * another revision is `409 conflict`, none with an address is `400 validation_failed`).
 */
export const HELP_CONTACT_CONSENT_REVISION = "help-contact-consent-2026-10-15";
/**
 * ADR 0072 (2026-10-18): the first wording of the page-reading question — the page's visible text "is sent to wetalk's
 * assistant". Every `help_page_reading` row written before ADR 0076 holds it (migration 0170's default), and a
 * `PUT /v1/help/page-reading` that names no wording is read as it (an older page showed it).
 */
export const HELP_PAGE_READING_FIRST_REVISION = "help-page-reading-2026-10-18";
/**
 * ADR 0076 (2026-10-20): the wording shown now — the first one plus "A wetalk person can see it too if you talk to one
 * or send us a message." Only `allowed` under this wording lets an operator see page text.
 */
export const HELP_PAGE_READING_REVISION = "help-page-reading-2026-10-20";
/** Every page-reading wording a person may have answered (migration 0170's CHECK), oldest first. */
export const HELP_PAGE_READING_REVISIONS = [HELP_PAGE_READING_FIRST_REVISION, HELP_PAGE_READING_REVISION];
/** The wordings under which an `allowed` answer covers a wetalk person seeing the page (ADR 0076). */
export const HELP_PAGE_READING_OPERATOR_REVISIONS = Object.freeze([HELP_PAGE_READING_REVISION]);
export function isHelpPageReadingRevision(value) {
    return typeof value === "string" && HELP_PAGE_READING_REVISIONS.includes(value);
}
//# sourceMappingURL=revision.js.map